<template>
  <!--
    The view for the image collections -component
  -->
  <Portlet
    :title="$t('menu.collections')"
    icon="images"
  >
    <template slot="buttons">
      <button 
        class="btn btn-sm btn-primary float-right mt-2 mb-2" 
        @click="showSidebarAdd"
      >
        <font-awesome-icon
          class="mr-1"
          icon="plus"
        />
        <span>
          {{ $t('add') }}
        </span>
      </button>
      <div class="clearfix" />
    </template>
    <CollectionsList
      ref="collectionsList"
      @reloadAuditLogs="reloadAuditLogs"
    />
    <DatabaseAuditLogList
      ref="databaseAuditLogList"
      :is-collections="true"
      @reload="reloadCollectionList"
    />
  </Portlet>
</template>

<script>
export default {
  name: "Collections",
  components: {
    CollectionsList: () => import('@/components/VideoPostprocessing/ImageCollections/CollectionsList.vue'),
    DatabaseAuditLogList: () => import('@/components/DatabaseAuditLogs/DatabaseAuditLogsList.vue')
  },
  metaInfo () {
    return {
      title: this.$t('menu.collections')
    }
  },
  methods: {
    showSidebarAdd () {
      this.$refs.collectionsList.showSidebarAdd();
    },
    reloadAuditLogs () {
      this.$refs.databaseAuditLogList.reloadAuditLogs();
    },
    reloadCollectionList () {
      this.$refs.collectionsList.reloadCollections();
    }
  }
}
</script>